import type { OrderWriteRequest } from 'apiConnector/secondary-market/shared/order';
import type { CreateTradeResponse } from 'apiConnector/secondary-market/shared/trade';
import type { OrderActionType } from 'state/secondaryMarket/shared/actions';
import type { SecondaryWorkspaceType } from 'state/workspaces/model';

export function secondaryMarketTradeActionsFactory<
  CreateTradeReq extends OrderWriteRequest,
  CreateTradeRes extends CreateTradeResponse,
>(actionType: Exclude<OrderActionType, 'CP_ORDER'>) {
  return {
    secondaryMarketTradeRequested: (tabId: string, workspaceType: SecondaryWorkspaceType, request: CreateTradeReq) => {
      return {
        type: `SECONDARY_MARKET_${actionType}_TRADE_REQUESTED` as const,
        tabId,
        workspaceType,
        request,
      };
    },
    secondaryMarketTradeReceived: (tabId: string, data: CreateTradeRes, timestamp: Date) => {
      return {
        type: `SECONDARY_MARKET_${actionType}_TRADE_RECEIVED` as const,
        tabId,
        data,
        timestamp,
      };
    },

    secondaryMarketTradeRejected: (tabId: string, error: string, timeout?: number) => {
      return {
        type: `SECONDARY_MARKET_${actionType}_TRADE_REJECTED` as const,
        tabId,
        error,
        timeout,
      };
    },
    secondaryMarketTradeFailed: (tabId: string, error: string, timeout?: number) => {
      return {
        type: `SECONDARY_MARKET_${actionType}_TRADE_FAILED` as const,
        tabId,
        error,
        timeout,
      };
    },
  };
}
